import React, { useEffect } from "react";

function EmailMarketing() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return <div>EmailMarketing</div>;
}

export default EmailMarketing;
